import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M21 16H3V14H21V16ZM21 10H3V8H21V10Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "MenuDuo"
);
